import defer from 'lib/defer'

export default async function awaitFor(ms){
  await new Promise(r => { defer(r, ms) })
}
